<template>
    <div class="failed-extraction-state">
        <div class="has-text-centered">
            <span class="icon is-large has-text-danger mb-4">
                <i class="fas fa-times-circle fa-3x"></i>
            </span>
            <h4 class="title is-5 mb-3">
                {{ translate("page.category_manager.extraction_failed_title") }}
            </h4>
            <p class="mb-4">
                {{ translate("page.category_manager.extraction_failed_description") }}
            </p>
            <div class="content has-text-left failed-extraction-hints">
                <p class="has-text-weight-semibold mb-2">
                    {{ translate("page.category_manager.extraction_failed_hints_title") }}
                </p>
                <ul>
                    <li>{{ translate("page.category_manager.extraction_failed_hint_1") }}</li>
                    <li>{{ translate("page.category_manager.extraction_failed_hint_2") }}</li>
                    <li>{{ translate("page.category_manager.extraction_failed_hint_3") }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { translate } from "../../Common/translations";
</script>

<style scoped>
    .failed-extraction-state {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        padding: 2rem;
    }

    .failed-extraction-hints {
        max-width: 400px;
        margin: 0 auto;
        background: var(--bulma-background);
        padding: 1rem 1.5rem;
        border-radius: 6px;
    }

    .failed-extraction-hints ul {
        margin-top: 0.5rem;
        margin-bottom: 0;
    }
</style>
